import { ChangeDetectionStrategy, Component } from '@angular/core';
// eslint-disable-next-line @tseslint/no-unused-vars
import { OverviewHeaderComponent } from '../../overview-header.component';
// eslint-disable-next-line @tseslint/no-unused-vars
import { OverviewHeaderRefreshComponent } from './components/overview-header-refresh/overview-header-refresh.component';
// eslint-disable-next-line @tseslint/no-unused-vars
import { OverviewHeaderSettingsComponent } from './components/overview-header-settings/overview-header-settings.component';

/**
 * Add this Component to {@link OverviewHeaderComponent | app-overview-header} to add the operators,
 * that you want to heave in the header. This Component is just a Wrapper to make the {@link OverviewHeaderComponent | app-overview-header}
 * more structured.
 *
 * You can add following Operators to this wrapper:
 * - {@link OverviewHeaderRefreshComponent | app-overview-header-refresh}
 * - {@link OverviewHeaderSettingsComponent | app-overview-header-settings}
 *
 * @example
 *
 * ```html
 * <app-overview-header>
 *   <!-- other overview-header child-components... -->
 *   <app-overview-header-operators>
 *     <!-- for example: -->
 *     <app-overview-header-refresh />
 *   </app-overview-header-operators>
 *   <!-- other overview-header child-components... -->
 * </app-overview-header>
 * ```
 */
@Component({
  selector: 'app-overview-header-operators',
  standalone: true,
  imports: [],
  templateUrl: './overview-header-operators.component.html',
  styleUrl: './overview-header-operators.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
// eslint-disable-next-line @tseslint/no-extraneous-class
export class OverviewHeaderOperatorsComponent {}
